const state = {
  snackbar: {
    show: false,
    color: 'default',
    text: '',
  }
}

const getters = {
  getSnackbar: state => state.snackbar
}

const mutations = {
  showSnackbar (state, payload) {
    state.snackbar.show = false
    setTimeout(() => {
      state.snackbar.show = true
      state.snackbar.color = payload.color
      state.snackbar.text = payload.text
    }, 250)
  },
  hideSnackbar (state) {
    state.snackbar.show = false
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/UI.js